<template>
  <div v-if="loading">
    <loadingAnimation />
  </div>
  <div v-else class="ctpx-common-thread ctpx-common-thread--lp">
    <div
      class="bg"
      :style="{
        backgroundImage:
          'url(' + landingpage.heroImage.data.attributes.url + ')',
      }"
    >
      <img
        :src="landingpage.logo.data.attributes.url"
        alt="Cotopaxi Common Thread"
        class="lp-logo"
      />
    </div>
    <div class="msearch d-block d-md-none">
      <div class="container-fluid">
        <div class="row">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Search Common Thread"
              aria-label="Search Common Thread"
              aria-describedby="basic-addon2"
              v-model="searchQuery"
              @keyup.enter="searchArchives(searchQuery)"
            />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xml:space="preserve"
                  baseProfile="tiny"
                  class="icon icon-search"
                  viewBox="0 0 200 200"
                >
                  <path
                    fill-rule="evenodd"
                    d="m168.76 158.74-32.09-32.1a60.21 60.21 0 1 0-10.02 10.02l32.1 32.09a7.08 7.08 0 1 0 10.01-10.01zm-46.49-37.15-.36.32c-.11.11-.22.23-.32.36a46.04 46.04 0 1 1 .68-.68z"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="search">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 col-xl-5">
            <div
              class="row g-0 gap-3 d-flex justify-content-sm-center justify-content-md-between"
            >
              <div class="col">
                <a
                  @click="activate(1), updateContentByCategory('People')"
                  :class="{ active: active_el == 1 }"
                  class="btn btn-tan"
                  >People</a
                >
              </div>
              <!--col-->
              <div class="col">
                <a
                  @click="activate(2), updateContentByCategory('Planet')"
                  :class="{ active: active_el == 2 }"
                  class="btn btn-tan"
                  >Planet</a
                >
              </div>
              <!--col-->
              <div class="col">
                <a
                  @click="activate(3), updateContentByCategory('Gear')"
                  :class="{ active: active_el == 3 }"
                  class="btn btn-tan"
                  >Gear</a
                >
              </div>
              <!--col-->
            </div>
            <!--.row-->
          </div>
          <!--.col-md-5-->
          <div class="col-md-6 col-xl-7 d-none d-md-block">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Search Common Thread Stories and Films"
                aria-label="Search Common Thread Stories and Films"
                aria-describedby="basic-addon2"
                v-model="searchQuery"
                @keyup.enter="searchArchives(searchQuery)"
              />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xml:space="preserve"
                    baseProfile="tiny"
                    class="icon icon-search"
                    viewBox="0 0 200 200"
                  >
                    <path
                      fill-rule="evenodd"
                      d="m168.76 158.74-32.09-32.1a60.21 60.21 0 1 0-10.02 10.02l32.1 32.09a7.08 7.08 0 1 0 10.01-10.01zm-46.49-37.15-.36.32c-.11.11-.22.23-.32.36a46.04 46.04 0 1 1 .68-.68z"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <!--.col-7-->
        </div>
        <!--.row-->
      </div>
      <!--.container-fluid-->
    </div>
    <div class="container-fluid">
      <!--.mobile-swiper-->
      <div class="mobile-only mobile-swiper row recent ctpx-short-sec">
        <h3 class="display-hero-sub lead">{{ storiesHeader }}</h3>
        <swiper
          :modules="modules"
          :slides-per-view="'auto'"
          :centeredSlides="true"
          :space-between="10"
          :pagination="{ clickable: true }"
          :lazy="true"
          :loop="true"
          @swiper="onSwiper"
        >
          <template v-for="story in stories" :key="story.id">
            <swiper-slide>
              <storyCard :storyId="story.id" :storyDetails="story.attributes" />
            </swiper-slide>
          </template>
        </swiper>

        <div class="col-12 mt-4 d-flex justify-content-center text-center">
          <a
            v-if="selectedCategory"
            :href="'/pages/common-thread-archive?category=' + selectedCategory"
            class="more-link"
            >More Stories ></a
          >
          <a v-else :href="'/pages/common-thread-archive/'" class="more-link"
            >More Stories ></a
          >
        </div>
      </div>
      <!-- non swiper on desktop -->
      <div class="row recent ctpx-short-sec hidden-mobile">
        <h3 class="display-hero-sub lead">{{ storiesHeader }}</h3>
        <template v-for="story in stories" :key="story.id">
          <storyCard :storyId="story.id" :storyDetails="story.attributes" />
        </template>
        <a
          v-if="selectedCategory"
          :href="'/pages/common-thread-archive?category=' + selectedCategory"
          class="more-link"
          >More Stories ></a
        >
        <a v-else :href="'/pages/common-thread-archive/'" class="more-link"
          >More Stories ></a
        >
      </div>
      <div class="row vids" v-if="videos != ''">
        <swiper
          :modules="modules"
          :slides-per-view="'auto'"
          :centeredSlides="true"
          :space-between="10"
          :pagination="{ clickable: true }"
          :lazy="true"
          :loop="true"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          :breakpoints="{
            '768': {
              spaceBetween: 25,
            },
          }"
        >
          <template v-for="video in videos">
            <swiper-slide>
              <a
                v-bind:href="
                  '/pages/common-thread-story/' + video.attributes.vanityUrl
                "
              >
                <div
                  v-if="video.attributes.heroMedia.heroPhoto.data"
                  class="vid-bg"
                  :style="{
                    backgroundImage: `url(${video.attributes.heroMedia.heroPhoto.data.attributes.url})`,
                  }"
                ></div>
                <div
                  v-else
                  class="vid-bg"
                  :style="{
                    backgroundImage: `url('https://cdn.shopify.com/s/files/1/0281/7544/files/default-insta-header.jpg')`,
                  }"
                ></div>
                <div class="slide-bg"></div>
                <div class="slide-des">
                  <span class="cat">{{
                    video.attributes.category.data.attributes.categoryName
                  }}</span>
                  <span class="video-icon"></span>
                  <h1 class="">{{ video.attributes.title }}</h1>
                  <p>
                    {{ video.attributes.description }}
                  </p>
                  <div class="info">
                    <span class="date">{{
                      formatDateString(video.attributes.posted_date)
                    }}</span>
                    &bullet;
                    <span class="time">{{ video.attributes.readTime }}</span>
                  </div>
                </div>
              </a>
            </swiper-slide>
          </template>
        </swiper>
        <a
          v-if="selectedCategory"
          :href="
            '/pages/common-thread-archive?videos=true&category=' +
            selectedCategory
          "
          class="more-link"
          >More Stories ></a
        >
        <a
          v-else
          :href="'/pages/common-thread-archive?videos=true'"
          class="more-link"
          >More Stories ></a
        >
      </div>
      <!--.row-->
      <div class="ctpx-sec row ambass">
        <h3 class="display-hero-sub lead">Meet Our Do Good Ambassador Team</h3>
        <swiper
          :modules="modules"
          :slides-per-view="1"
          :space-between="50"
          :lazy="true"
          navigation
          @swiper="onSwiper"
          @slideChange="onSlideChange"
        >
          <template v-for="ambass in ambassadors">
            <swiper-slide>
              <div class="row">
                <div class="col-md-6 image-col">
                  <img
                    :src="ambass.attributes.image.data.attributes.url"
                    draggable="false"
                    class="swiper-lazy"
                  />
                </div>
                <div class="col-md-6 text-col">
                  <div class="content row">
                    <div class="col col-md-11 col-xl-9 offset-xl-1">
                      <label>{{ ambass.attributes.description }}</label>
                      <h3>{{ ambass.attributes.name }}</h3>
                      <span
                        v-for="(social, index) in ambass.attributes.social"
                        class="social"
                      >
                        <a :href="social.link" target="_blank">{{
                          social.handle
                        }}</a
                        ><span
                          v-if="index + 1 < ambass.attributes.social.length"
                          >&nbsp;|&nbsp;</span
                        >
                      </span>
                      <div class="mobile-only">
                        <p
                          v-if="!showSection"
                          v-html="ambass.attributes.bodyTruncated"
                        ></p>
                        <p v-else v-html="ambass.attributes.body"></p>
                        <div class="mobile-tog" v-on:click="toggle">
                          <span v-if="showSection">SHOW LESS &#60;</span>
                          <span v-else="!showSection">READ MORE &#62;</span>
                        </div>
                      </div>
                      <!--.mobile-only-->
                      <div class="hidden-mobile">
                        <p v-html="ambass.attributes.body"></p>
                      </div>
                    </div>
                    <!--.col-10-->
                  </div>
                  <!--.content-->
                </div>
                <!--.col-md-6-->
              </div>
            </swiper-slide>
          </template>
        </swiper>
      </div>
      <!--.row-->
    </div>
    <!-- .container-fluid -->
    <!--hide bc insta token is down <div class="container-fluid">
      <instagram />
    </div> -->
    <!-- spotify section -->
    <spotify
      :spotifyTitle="spotifyTitle"
      :playlistLink="spotifyLink"
      :bgImg="spotifyImg"
      :description="spotifyDesc"
    />

    <section class="ctpx-panel-sec storyshare" id="">
      <div class="panel content">
        <div class="row">
          <div class="col">
            <h3 class="display-3">Submit Your Story</h3>
            <p>
              Got a story that you want to share? We'd love to hear it! Use the
              form below to send us your pitch!
            </p>
            <p>
              <a
                href="https://forms.clickup.com/2295570/f/261rj-16450/9KMC7ORL89J8N7P8UR"
                class="btn btn-primary"
                target="_blank"
                >Submit a Story</a
              >
            </p>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
      </div>
      <div class="panel media">
        <img
          src="https://cdn.shopify.com/s/files/1/0281/7544/files/storyshare2.jpg"
          alt="Submit a Story"
        />
      </div>
      <!-- .panel -->

      <!-- .panel -->
    </section>
  </div>
</template>

<script src="./ctrl-common-thread.js"></script>
